import { render, staticRenderFns } from "./validCode.vue?vue&type=template&id=6428a708&scoped=true"
import script from "./validCode.vue?vue&type=script&lang=js"
export * from "./validCode.vue?vue&type=script&lang=js"
import style0 from "./validCode.vue?vue&type=style&index=0&id=6428a708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6428a708",
  null
  
)

export default component.exports